import React, { useState } from 'react';
import { Button } from './ui';
import { ShieldCheck, Plus, Minus, Clock, Lock, Zap, FileText } from 'lucide-react';
import { trackInitiateCheckout } from './useMetaPixel';
const CHECKOUT_URL = 'https://conduca-infantil.impultienda.ar/checkout';
export function Guarantee() {
  return <section className="py-9 px-4 bg-gradient-to-b from-cream-50 to-white" data-id="element-179" data-mp="2wloc3ggre1qv">
      <div className="max-w-2xl mx-auto text-center" data-id="element-180" data-mp="3u854c7amxp5r">
        <div className="w-16 h-16 mx-auto mb-3 rounded-full bg-teal-100 border border-teal-300 flex items-center justify-center" data-id="element-181" data-mp="3u7lmsrowd2s9">
          <ShieldCheck className="w-9 h-9 text-teal-600" data-id="element-182" data-mp="3kilm93uqxzby" />
        </div>
        <h2 className="text-2xl md:text-3xl font-black text-navy tracking-tight" data-id="element-183" data-mp="3kgin9ubm8vv3">
          GARANTÍA DE 7 DÍAS
        </h2>
        <span className="inline-block mt-2 mb-4 bg-teal-500 text-white text-[11px] font-bold uppercase tracking-widest px-3 py-1 rounded-full" data-id="element-184" data-mp="gtica5kkuwr6">
          ✓ Compra sin riesgo
        </span>

        <div className="rounded-2xl border border-teal-500/50 bg-navy text-center px-5 py-6 sm:px-7 sm:py-7 shadow-[0_20px_45px_-28px_rgba(67,168,158,0.9)]" data-id="element-185" data-mp="c0yx5468rtk9">
          <p className="text-base sm:text-lg text-white font-semibold leading-snug" data-id="element-186" data-mp="2ljmzclxc7eki">
            Accedé al Kit. Exploralo. Ponelo en práctica.
          </p>
          <p className="text-sm sm:text-base text-white/60 mt-2 leading-snug" data-id="element-187" data-mp="2cscxm7c5wc4q">
            Si durante los próximos 7 días sentís que no era lo que esperabas:
          </p>
          <p className="text-6xl sm:text-7xl font-black text-teal-400 leading-none mt-4" data-id="element-188" data-mp="1xxghl7y42kh3">
            100%
          </p>
          <p className="text-lg sm:text-xl font-bold text-white uppercase tracking-tight mt-1.5" data-id="element-189" data-mp="1ounr36wr6csb">
            De tu dinero de vuelta
          </p>
          <p className="text-sm text-white/50 mt-2" data-id="element-190" data-mp="1tujtj1psxw5r">
            Simple y sin complicaciones.
          </p>
        </div>

        <p className="text-sm text-ink-soft mt-3" data-id="element-191" data-mp="3j6lxl13oguki">
          Tenés 7 días para decidir si el Kit es para vos.
        </p>
      </div>
    </section>;
}
export function FAQ() {
  const faqs = [{
    q: '¿Tengo que leer los 3 tomos antes de empezar?',
    a: 'No. El Kit está organizado para que puedas avanzar progresivamente y consultar las secciones y herramientas que más necesitás.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Después de completar tu compra recibís acceso digital al Kit.'
  }, {
    q: '¿Es un producto físico?',
    a: 'No. El Kit de Conducta Infantil es 100% digital.'
  }, {
    q: '¿Puedo consultarlo desde el celular?',
    a: 'Sí. Podés acceder al material desde dispositivos compatibles y consultarlo cuando lo necesites.'
  }, {
    q: '¿Qué pasa si nuestro principal problema son las rabietas?',
    a: 'El Tomo 2 está enfocado especialmente en límites, rabietas y emociones y se complementa con las herramientas prácticas del Kit.'
  }, {
    q: '¿Y si lo que más nos cuesta son las rutinas?',
    a: 'El Tomo 3 trabaja específicamente rutinas y planificación de conducta y se complementa con el Pack de Rutinas Visuales.'
  }, {
    q: '¿Incluye herramientas prácticas?',
    a: 'Sí. Además de los 3 tomos recibís los 5 bonos incluidos.'
  }, {
    q: '¿Reemplaza el acompañamiento profesional?',
    a: 'No. Es un recurso educativo para madres, padres y cuidadores y no sustituye evaluación, diagnóstico o acompañamiento profesional cuando sea necesario.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí. La compra cuenta con una garantía de 7 días según las condiciones indicadas.'
  }];
  const [open, setOpen] = useState<number | null>(0);
  return <section className="px-4 py-9 bg-gradient-to-b from-cream-50 to-cream-100 border-t border-cream-300" data-id="element-192" data-mp="1nc2xj335763l">
      <div className="max-w-3xl mx-auto" data-id="element-193" data-mp="1scgvttexz1of">
        <h2 className="text-2xl md:text-3xl font-bold text-navy text-center mb-6 flex items-center justify-center gap-3" data-id="element-194" data-mp="1xa0jtl1fystk">
          <span className="text-teal-600" data-id="element-195" data-mp="21bvlwrr75a8e">❓</span> PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-196" data-mp="2yz5j1mz2nrhv">
          {faqs.map((faq, i) => <div key={i} className="border border-cream-300 rounded-xl bg-white overflow-hidden" data-id="element-197" data-mp="2u0vrrnggxb1j" data-mpi={i}>
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpen(open === i ? null : i)} data-id="element-198" data-mp="37qz49mpjpqds">
                <span className="font-bold text-navy pr-8" data-id="element-199" data-mp="2g1mk5c6bvp96">{faq.q}</span>
                {open === i ? <Minus className="w-5 h-5 text-teal-600 shrink-0" data-id="element-200" data-mp="2b3kta52nuln5" /> : <Plus className="w-5 h-5 text-ink-soft shrink-0" data-id="element-201" data-mp="2p3cbyj44gq7h" />}
              </button>
              {open === i && <div className="px-6 pb-4 text-ink-muted" data-id="element-202" data-mp="4bjvspwtfour">{faq.a}</div>}
            </div>)}
        </div>
      </div>
    </section>;
}
export function CostOfInaction() {
  return <section className="py-9 px-3 sm:px-4 bg-gradient-to-b from-white to-cream-100" data-id="element-203" data-mp="7thhij60dce9">
      <div className="max-w-5xl mx-auto mb-9" data-id="element-204" data-mp="7vu4xbujceyp">
        <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-navy text-center mb-4" data-id="element-205" data-mp="bw48khuuutae">
          ⚖️ ¿CUÁNTO TE CUESTA SEGUIR IMPROVISANDO?
        </h2>

        <div className="rounded-2xl border border-cream-400 overflow-hidden shadow-[0_14px_36px_-24px_rgba(16,42,67,0.45)]" data-id="element-206" data-mp="2ud8bsj33enx">
          <table className="w-full text-left border-collapse table-fixed" data-id="element-207" data-mp="qjpbaantiqhs">
            <colgroup data-id="element-208" data-mp="visj22v6natg">
              <col className="w-[46%]" data-id="element-209" data-mp="vjbrmsyy0mut" />
              <col className="w-[54%]" data-id="element-210" data-mp="vi8y0da8k6b7" />
            </colgroup>
            <thead data-id="element-211" data-mp="gt4hd0j3aa57">
              <tr className="bg-cream-100 border-b border-cream-400" data-id="element-212" data-mp="gtmlskfwnuo7">
                <th className="px-3 sm:px-5 py-2.5 text-[11px] sm:text-xs font-semibold uppercase tracking-wider text-ink-soft" data-id="element-213" data-mp="lsh1hdikt343">
                  Sin un sistema claro
                </th>
                <th className="px-3 sm:px-5 py-2.5 text-[11px] sm:text-xs font-bold uppercase tracking-wider text-teal-700 bg-teal-50" data-id="element-214" data-mp="1ea1uihoik9no">
                  Costo real
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-cream-300" data-id="element-215" data-mp="1j7gw2n18q9y1">
              {[['Repetir lo mismo una y otra vez', 'Frustración para ambos'], ['Improvisar frente a una rabieta', 'No saber qué hacer cuando más lo necesitás'], ['Límites que cambian según el momento', 'Más discusiones y menos claridad'], ['Rutinas sin estructura', 'Los mismos conflictos todos los días'], ['Terminar perdiendo la paciencia', 'Culpa después del conflicto'], ['Cada adulto actuando diferente', 'Menos consistencia para tu hijo']].map(([problem, cost]) => <tr key={problem} className="bg-white" data-id="element-216" data-mp="2t45mkv2og2gu">
                  <td className="px-3 sm:px-5 py-2.5 sm:py-3 align-middle text-[13px] sm:text-base text-ink-muted leading-snug" data-id="element-217" data-mp="2y2qnyxto0s6v">
                    {problem}
                  </td>
                  <td className="px-3 sm:px-5 py-2.5 sm:py-3 align-middle text-[13px] sm:text-base font-semibold text-navy leading-snug bg-teal-50/70" data-id="element-218" data-mp="373y7g9rivogw">
                    {cost}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-219" data-mp="2jevsj9o9w9q3">
        {/* Final CTA Block */}
        <div className="text-center" data-id="element-220" data-mp="2jcsty192189r">
          <p className="text-xl md:text-2xl font-bold text-navy" data-id="element-221" data-mp="2o5lyop4iwglu">
            Tu próximo momento difícil puede ser diferente.
          </p>
          <p className="text-xl md:text-2xl font-black text-teal-600 mt-1" data-id="element-222" data-mp="1qpojvhv3u3r4">
            Esta vez vas a saber qué hacer.
          </p>

          <p className="mt-8 flex items-center justify-center gap-2 font-bold text-navy text-base md:text-lg" data-id="element-223" data-mp="p1pf6yuus0ju">
            <Clock className="w-5 h-5 text-coral-500" data-id="element-224" data-mp="k35pqoh1w6mq" />
            EL PRECIO CIERRA EN:
          </p>

          <div className="mt-4 flex items-start justify-center gap-3 sm:gap-6" data-id="element-225" data-mp="y2x08f8cz4vz">
            {[{
            value: '23',
            label: 'HS'
          }, {
            value: '59',
            label: 'MIN'
          }, {
            value: '52',
            label: 'SEG'
          }].map((unit, i) => <React.Fragment key={unit.label} data-id="element-226" data-mp="1hqnxbvyz72p5" data-mpi={i}>
                {i > 0 && <span className="text-[#C92F35] font-black text-4xl sm:text-5xl leading-none" aria-hidden="true" data-id="element-227" data-mp="1crjoj6fyr6zc">
                    :
                  </span>}
                <div className="text-center" data-id="element-228" data-mp="1ltat27yrp7rm">
                  <p className="tabular-nums font-black text-[#C92F35] text-5xl sm:text-6xl leading-none" data-id="element-229" data-mp="1lq56azdm2hz2">
                    {unit.value}
                  </p>
                  <p className="mt-2 text-[11px] font-semibold tracking-[0.3em] text-ink-soft" data-id="element-230" data-mp="2accjx113dmpl">
                    {unit.label}
                  </p>
                </div>
              </React.Fragment>)}
          </div>

          <div className="max-w-md mx-auto mt-8 rounded-3xl border-2 border-brand-500 bg-white p-5 sm:p-6 shadow-[0_24px_55px_-20px_rgba(6,182,212,0.65),0_0_0_7px_rgba(6,182,212,0.08)]" data-id="element-231" data-mp="20gjc1uybihe5">
            <h4 className="font-black text-navy text-xl tracking-tight leading-tight" data-id="element-232" data-mp="1rg3air14xkbx">
              🧩 KIT DE CONDUCTA INFANTIL
            </h4>
            <p className="text-sm text-teal-600 font-bold mt-1" data-id="element-233" data-mp="1hnfdpwa5ngd7">
              3 Tomos + 5 Bonos
            </p>
            <span className="inline-block mt-2 bg-navy text-white text-[9px] font-bold uppercase tracking-[0.18em] px-2.5 py-1 rounded-full" data-id="element-234" data-mp="13ph2gzr4s01x">
              Oferta de lanzamiento
            </span>

            <p className="text-xs font-semibold uppercase tracking-widest text-ink-soft mt-4" data-id="element-235" data-mp="348yje8bzq4eu">
              Antes{' '}
              <span className="line-through text-coral-600" data-id="element-236" data-mp="39anxjwuiey75">USD 49.99</span>
            </p>
            <p className="text-5xl sm:text-6xl font-black text-navy leading-none tracking-tight mt-1" data-id="element-237" data-mp="2vamuqbuopgp1">
              USD 19.99
            </p>
            <span className="inline-block mt-2.5 bg-teal-500 text-white text-[11px] font-bold uppercase tracking-wide px-3 py-1 rounded-full" data-id="element-238" data-mp="3nxz7xveygc5o">
              Ahorrás USD 30
            </span>

            <p className="text-[11px] text-ink-muted mt-3" data-id="element-239" data-mp="3s1f28l3jy0f7">
              ✓ Pago único · ⚡ Acceso inmediato
            </p>

            <Button className="w-full mt-4 text-base py-4 shadow-[0_14px_30px_-12px_rgba(6,182,212,0.85)]" onClick={() => {
            trackInitiateCheckout();
            window.location.href = CHECKOUT_URL;
          }} data-id="element-240" data-mp="3j6qyizdmkqsi">
              → QUIERO MI KIT POR USD 19.99
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-ink-muted mt-6" data-id="element-241" data-mp="ov65noeceyjk">
            <span className="flex items-center" data-id="element-242" data-mp="ktb9szf6ldd6">
              <Lock className="w-4 h-4 mr-1 text-ink-soft" data-id="element-243" data-mp="yn2799fn16sj" /> Pago seguro
            </span>
            <span className="flex items-center" data-id="element-244" data-mp="tn7ipcjc4tan">
              <Zap className="w-4 h-4 mr-1 text-amber-500" data-id="element-245" data-mp="tohge0m9zzgr" /> Acceso inmediato
            </span>
            <span className="flex items-center" data-id="element-246" data-mp="5yeuk28yfpql">
              <ShieldCheck className="w-4 h-4 mr-1 text-emerald-600" data-id="element-247" data-mp="1x1kth2qr2ee" /> Garantía
              7 días
            </span>
            <span className="flex items-center" data-id="element-248" data-mp="fxccunfsen15">
              <FileText className="w-4 h-4 mr-1 text-teal-600" data-id="element-249" data-mp="ftyctlulipwv" /> 100% digital
            </span>
          </div>
        </div>
      </div>
    </section>;
}
export function Footer() {
  return <footer className="bg-cream-100 py-8 px-5 sm:px-6 border-t border-cream-300" data-id="element-250" data-mp="1rdkhqvioyafz">
      <div className="max-w-3xl mx-auto text-center" data-id="element-251" data-mp="1mc4ztcbt8k1t">
        <div className="inline-flex items-center gap-2" data-id="element-252" data-mp="1udm522s3nr9q">
          <span className="text-xl" data-id="element-253" data-mp="1uf5illmdfo7t">🧩</span>
          <span className="text-teal-600 font-bold tracking-widest uppercase" data-id="element-254" data-mp="1ydwke61s7u19">
            PUNTO DIGITAL™
          </span>
        </div>

        <p className="text-sm text-ink-muted leading-snug mt-2 max-w-xl mx-auto" data-id="element-255" data-mp="23ek7whqsxsqq">
          Herramientas prácticas para acompañar la conducta, las emociones, los
          límites y las rutinas.
        </p>
        <p className="text-sm text-ink-soft font-semibold italic leading-snug mt-1.5 max-w-xl mx-auto" data-id="element-256" data-mp="1aqwoh619p85o">
          “Porque criar no viene con un manual... pero no tenés que improvisar
          frente a cada momento difícil.”
        </p>

        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-sm text-ink-muted mt-3" data-id="element-257" data-mp="1pdq0a1bkvvt4">
          <a href="mailto:supportpuntodigital@gmail.com" className="hover:text-teal-600 transition-colors" data-id="element-258" data-mp="rzdqjdm3okai">
            📧 supportpuntodigital@gmail.com
          </a>
          <span className="text-teal-300" aria-hidden="true" data-id="element-259" data-mp="pefqzv3w2w3o">
            •
          </span>
          <a href="#" className="hover:text-teal-600 transition-colors" data-id="element-260" data-mp="ketczjg8lbtt">
            🌐 www.puntodigital.store
          </a>
        </div>

        <hr className="w-[82%] mx-auto my-4 border-t border-teal-200" data-id="element-261" data-mp="fe5bg3udtclc" />

        <p className="text-xs text-ink-faint" data-id="element-262" data-mp="afvh1vgheg0s">
          © Punto Digital™ 2026 — Todos los derechos reservados.
        </p>
        <p className="text-[11px] text-ink-faint mt-1" data-id="element-263" data-mp="6gv2wq8y81k4">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>

        <p className="text-sm text-teal-600 font-semibold italic mt-4" data-id="element-264" data-mp="3sumqrqj6o976">
          🧩 “Menos improvisación. Más herramientas para saber cómo actuar.”
        </p>
      </div>
    </footer>;
}